var map = {
	"./logo-sia.png": "a959",
	"./section-icons/audience.png": "4aa3",
	"./section-icons/audiencia-diaria.png": "3dbe",
	"./section-icons/bbb-panel.png": "993d",
	"./section-icons/canais-pay-tv.png": "3880",
	"./section-icons/consolidado-faixa.png": "829f",
	"./section-icons/consolidado-novelas.png": "55f2",
	"./section-icons/consolidado-praca-faixa.png": "33f3",
	"./section-icons/consolidado-praca-programa.png": "04c1",
	"./section-icons/consolidado-programa.png": "56ee",
	"./section-icons/cross-plataform-view.png": "24e2",
	"./section-icons/digital.png": "e5a8",
	"./section-icons/globospot.png": "107b",
	"./section-icons/grade-diaria.png": "6248",
	"./section-icons/journey-map.png": "50e6",
	"./section-icons/minuto-a-minuto.png": "66b4",
	"./section-icons/multiplataform-icon.png": "4f67",
	"./section-icons/outras-medicoes.png": "2bed",
	"./section-icons/pay-tv.png": "e91c",
	"./section-icons/pesquisa-oficial.png": "dc8e",
	"./section-icons/programas-pay-tv.png": "a92d",
	"./section-icons/ranking-canais.png": "8dd8",
	"./section-icons/ranking-programas.png": "846e",
	"./section-icons/realtime.png": "ca53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";